import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { formatNumber, getData } from "../../../lib/commonFunctions";
import { GovernyInfo } from "../../../lib/types";
import { openContentPopup } from "../../../store/actions";
import { CONTENT_CONTEXT } from "../../../lib/enums";
import AllianceInfoLink from "../../Common/AllianceInfoLink";

interface IProps {
  govId: number;
}

const GovernorateInfo = ({
  govId
}: IProps) => {
  const [governorate, setGovernorate] = useState<GovernyInfo | null>(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const getGovernorate = async () => {
      const governorateData = await getData(`/api/info/governorate/${govId}`);
      setGovernorate(governorateData);
    };
    getGovernorate();
  }, [govId]);

  return (governorate
    ? <>
        <div className="dialog-content">
          <table className="table">
            <tr>
              <th>Land</th>
              <td>{formatNumber(governorate.land)}</td>
            </tr>
            <tr>
              <th>Power</th>
              <td>{formatNumber(governorate.power)}</td>
            </tr>
            <tr>
              <th>Race</th>
              <td>{governorate.race.name}</td>
            </tr>
            <tr>
              <th>Alliance</th>
              <td>{governorate.alliance
                ? <AllianceInfoLink
                  allianceId={governorate.alliance.id}
                  name={governorate.alliance.name}
                />
                : "Non-alliance"}</td>
            </tr>
            <tr>
              <th>Last action</th>
              <td>
                {governorate.lastAction}
              </td>
            </tr>
          </table>
        </div>
        <footer className="dialog-footer">
          <a
            className="btn btn-blank btn-no-width"
            onClick={() => dispatch(openContentPopup({
              name: "Mail",
              title: "Mail",
              icon: "posta",
              presetRecipient: governorate.name
            }))}
          >
            Message
          </a>
          <a
            className="btn btn-blank btn-no-width"
            onClick={() => dispatch(openContentPopup({
              name: "OtherGovernorateProfile",
              title: governorate.name,
              icon: "popularita",
              governorate
            }))}
          >
            Detail
          </a>
          <a
            className="btn btn-blank btn-no-width"
            onClick={() => dispatch(openContentPopup({
              name: "Statistics",
              title: "Statistics",
              icon: "statistiky",
              statsType: CONTENT_CONTEXT.Governorate,
              presetSearch: governorate.name
            }))}
          >
            Stats
          </a>
        </footer>
    </> : <></>)
}

export default GovernorateInfo;
